import toWords from 'to-words';

export default function getWords(value) {
  const words = (value > 0) ? toWords(value, { currency: true }) : '-';
  return words;
}
